export default "__VITE_ASSET__af5ff135__"